if (!window) {
    throw ("A window object is required for configuration.");
}

let Config = {
    MaxFileSizeBytes: 100000000, // binary size (100mb)
    HistoryTickerIntervalMs: null,
    RecentHistoryDays: 5,
    RootApiUrl: null,
    AdalClientID: null,
    Environments: {
        "files.cubesmart.com": {
            HistoryTickerIntervalMs: 30000,
            RootApiUrl: "https://files.cubesmart.com/api/",
            "Azure": {
                "redirectURI": "https://files.cubesmart.com",
                "clientID": "c7a06f31-4e69-4389-973a-92245928d1dd",
                "tenantID": "435e4bc1-795f-4126-8964-8ab73c15c1bc",
                "apiScope": "api://c7a06f31-4e69-4389-973a-92245928d1dd/CubeUser.Read"
            }
        },
        "fileseast-dev.azurewebsites.net": {
            HistoryTickerIntervalMs: 30000,
            RootApiUrl: "https://fileseast-dev.azurewebsites.net/api/",
            "Azure": {
                "redirectURI": "https://fileseast-dev.azurewebsites.net",
                "clientID": "c7a06f31-4e69-4389-973a-92245928d1dd",
                "tenantID": "435e4bc1-795f-4126-8964-8ab73c15c1bc",
                "apiScope": "api://c7a06f31-4e69-4389-973a-92245928d1dd/CubeUser.Read"
            }
        },
        "localhost": {
            HistoryTickerIntervalMs: 5000,
            RootApiUrl: "https://localhost:7185",
            "Azure": {
                "redirectURI": "http://localhost:52260/site/dist/index.html",
                "clientID": "c7a06f31-4e69-4389-973a-92245928d1dd",
                "tenantID": "435e4bc1-795f-4126-8964-8ab73c15c1bc",
                "apiScope": "api://c7a06f31-4e69-4389-973a-92245928d1dd/CubeUser.Read"
            }
        }
    }
};

let envKey = window.location.hostname;

Object.assign(Config, Config.Environments[envKey]);

module.exports = Config;


// WEBPACK FOOTER //
// ./src/Config.js